// src/components/achievements/AchievementList.js
import React, { useEffect, useState } from 'react';
import NavLink from './../common/NavLink';
import RequireVip from '../RequireVip'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
} from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const AchievementList = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/achievements-list`)
      .then(res => res.json())
      .then(data => {
        setAchievements(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Błąd ładowania listy rankingów', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <Typography textAlign="center" py={8}>Ładowanie rankingów...</Typography>;

  const getColor = (color) => {
    if (color === 'green') return '#4caf50';
    if (color === 'red') return '#f44336';
    return '#bbbbbb';
  };

  // Podział na klubowe i ligowe
  const teamAchievements = achievements.filter(ach => ach.type === 'team' || !ach.type);
  const leagueAchievements = achievements.filter(ach => ach.type === 'league');

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 }, py: 4 }}>
	<Typography variant="h4" align="center" gutterBottom sx={{ color: '#fff', fontWeight: 700, mb: 5 }}>
        Wybryki statystyczne
      </Typography>
      <Typography variant="h5" align="center" gutterBottom sx={{ color: '#fff', fontWeight: 700, mb: 5 }}>
        Wybryki klubowe
      </Typography>

      {/* Tabela 1: Wybryki klubowe */}
      {teamAchievements.length > 0 && (
        <>
          <TableContainer component={Paper} sx={{ bgcolor: '#1a1a1a', borderRadius: 2, mb: 6 }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ bgcolor: '#111' }}>
                  <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '70%' }}>
                    <Typography align="center">Kategoria</Typography>
                  </TableCell>
                  <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '30%' }}>
                    <Typography align="center">Lider</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {teamAchievements.map((ach) => {
                  const top1 = ach.top1 || {};
                  const leagueDisplay = top1.group && top1.group.trim() !== ''
                    ? `${top1.league} (${top1.group})`
                    : top1.league || '-';

                  return (
                    <TableRow
                      key={ach.key}
                      component={NavLink}
                      to={ach.url}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' },
                        transition: 'background 0.2s',
                      }}
                    >
                      {/* Kategoria */}
                      <TableCell align="center">
                        <Typography
                          sx={{
                            fontSize: { xs: '0.9rem', md: '1.0rem' },
                            fontWeight: 600,
                            color: getColor(ach.color),
                          }}
                        >
                          {ach.title}
                        </Typography>
                      </TableCell>

                      {/* Lider (klub) */}
                      <TableCell align="center">
					    <RequireVip variant='short-text' requirement='poland'>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography
                            component={NavLink}
                            to={`/team/${top1.teamId}`}
                            sx={{
                              fontSize: { xs: '0.85rem', md: '0.95rem' },
                              fontWeight: 550,
                              color: '#fff',
                              lineHeight: 1.2,
                            }}
                          >
                            {top1.teamName || 'Brak danych'}
                          </Typography>

                          {top1.league && (
                            <Typography
                              component={NavLink}
                              to={`/liga/${top1.competitionId}`}
                              sx={{
                                fontSize: { xs: '0.75rem', md: '0.85rem' },
                                color: '#bbbbbb',
                                lineHeight: 1.2,
                              }}
                            >
                              {top1.league}
                            </Typography>
                          )}

                          {top1.group && top1.group.trim() !== '' && (
                            <Typography
                              component={NavLink}
                              to={`/liga/${top1.competitionId}`}
                              sx={{
                                fontSize: { xs: '0.65rem', md: '0.75rem' },
                                color: '#888888',
                                lineHeight: 1.2,
                              }}
                            >
                              ({top1.group})
                            </Typography>
                          )}
                        </Box>
						</RequireVip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
	  
	  <Typography variant="h5" align="center" gutterBottom sx={{ color: '#fff', fontWeight: 700, mb: 5 }}>
        Wybryki ligowe
      </Typography>

      {/* Tabela 2: Wybryki ligowe */}
      {leagueAchievements.length > 0 && (
        <>
          <TableContainer component={Paper} sx={{ bgcolor: '#1a1a1a', borderRadius: 2 }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ bgcolor: '#111' }}>
                  <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '70%' }}>
                    <Typography align="center">Kategoria</Typography>
                  </TableCell>
                  <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '30%' }}>
                    <Typography align="center">Lider</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {leagueAchievements.map((ach) => {
                  const top1 = ach.top1 || {};
                  const leagueDisplay = top1.group && top1.group.trim() !== ''
                    ? `${top1.league} (${top1.group})`
                    : top1.league || '-';

                  return (
                    <TableRow
                      key={ach.key}
                      component={NavLink}
                      to={ach.url}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' },
                        transition: 'background 0.2s',
                      }}
                    >
                      {/* Kategoria */}
                      <TableCell align="center">
                        <Typography
                          sx={{
                            fontSize: { xs: '0.9rem', md: '1.0rem' },
                            fontWeight: 600,
                            color: getColor(ach.color),
                          }}
                        >
                          {ach.title}
                        </Typography>
                      </TableCell>

                      {/* Lider (liga) */}
                      <TableCell align="center">
					   <RequireVip variant='short-text' requirement='poland'>

                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          {/* Nazwa ligi – formatowanie jak Drużyna */}
                          <Typography
                            component={NavLink}
                            to={`/liga/${top1.competitionId}`}
                            sx={{
                              fontSize: { xs: '0.85rem', md: '0.95rem' },
                              fontWeight: 550,
                              color: '#fff',
                              lineHeight: 1.2,
                            }}
                          >
                            {top1.league || 'Brak danych'}
                          </Typography>

                          {/* Grupa – mniejsza czcionka */}
                          {top1.group && top1.group.trim() !== '' && (
                            <Typography
                              sx={{
                                fontSize: { xs: '0.65rem', md: '0.75rem' },
                                color: '#888888',
                                lineHeight: 1.2,
                              }}
                            >
                              ({top1.group})
                            </Typography>
                          )}
                        </Box>
						</RequireVip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default AchievementList;